import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

/** Supports child elements of type `strong` */
@Component({
  selector: '[appMainButton]',
  templateUrl: './main-button.component.html',
  styleUrls: ['./main-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainButtonComponent {
  @HostBinding('class') get class(): { [key: string]: boolean } {
    return {
      [`color-${this.color}`]: true,
    };
  }

  @Input() icon?: 'cell' | 'udder' | 'pyramid';
  @Input() color: 'orange' | 'gras' | 'himmel' = 'orange';
}
